/*@flow*/
import hasOwn from 'lib/hasOwn';
import assert from 'lib/t/assert';

let registry: { [key: string]: TemplateT } = {};
type TemplateT = React$StatelessFunctionalComponent<*>;

export const add = (name: string, type: TemplateT): {[string]: TemplateT} => {
  assert(!has(name), '[proforma] Template ' + name + ' already exists.');
  return (registry = { ...registry, [name]: type });
};

export const load = (o: { [key: string]: TemplateT }): {[string]: TemplateT} =>
  (registry = { ...registry, ...o });

export const remove = (name: string): {[key: string]: TemplateT} => {
  delete registry[name];
  return registry;
};

export const clear = () => {
  registry = {};
};

export const has = (name: string): any => hasOwn.call(registry, name);

export const get = (name: string): TemplateT => {
  assert(
    has(name),
    '[proforma] Missing template ' + name + ' in the registry.'
  );
  return registry[name];
};

export default registry;
